import { render, staticRenderFns } from "./review-view.vue?vue&type=template&id=8a88c2d2&scoped=true"
import script from "./review-view.vue?vue&type=script&lang=js"
export * from "./review-view.vue?vue&type=script&lang=js"
import style0 from "./review-view.vue?vue&type=style&index=0&id=8a88c2d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a88c2d2",
  null
  
)

export default component.exports